// import menu_permission from '../../middleware/menu_permission';

const routes = [
  {
    path: '/newclient',
    component: () => import('../client/mainPage'),

    children: [
      {
        name: 'client.dashboard',
        path: '',

        component: () => import('../client/dashboard/clientDashboard'),
      },
      {
        name: 'client.profile',
        path: 'profile',
        props: true,

        component: () => import('../../Seller/SellerProfile/EditProfile'),
      },
      // {
      //   name: 'client.editprofile',
      //   path: 'editprofile',
      //   component: () => import('../../Seller/SellerProfile/EditProfile'),

      // },

      {
        path: 'projects',
        name: 'client.project',
        component: () => import('../client/project/projectReport'),
      },

      // create project
      {
        name: 'client.project.create',
        path: 'projects/create',
        component: () => import('../client/project/new_createproject'),
      },
      //publish project
      {
        name: 'client.project.publish',
        path: 'projects/published',
        component: () => import('../client/project/projectPublished'),
      },

      {
        name: 'client.project.new_create',
        path: 'create/project',
        component: () => import('../client/project/new_createproject'),
      },

      // create edit
      {
        name: 'client.project.edit',
        path: 'projects/:project_slug_id/edit',
        component: () => import('../client/project/new_createproject'),
      },
      // project preview after project create only for client
      {
        name: 'client.project.preview',
        path: 'projects/:project_slug_id/preview',
        component: () => import('../client/project/projectDetail/preview'),
      },

      //project details
      {
        path: 'projects/:project_slug_id/info',
        name: 'client.project.info',
        component: () => import('../client/project/projectDetail/projectDetails'),
      },

      //project details
      {
        path: 'projects/:project_slug_id/info/proposal/:user_name',
        name: 'client.project.info.proposal_details',
        component: () => import('../client/project/projectProposal/proposalDetails'),
      },

      {
        name: 'client.project.hired',

        path: 'projecthired',
        component: () => import('../client/project/hiredTab/hiredTalentForProject'),
      },

      {
        path: 'talents',
        name: 'talent',
        component: () => import('../client/talent/findtalent'),
      },
      {
        path: 'talents/:user_name',
        name: 'talentdetail',
        component: () => import('../client/talent/talentDetails'),
      },
      {
        path: 'chat',
        name: 'client.chat',
        component: () => import('../templates/chatBox'),
      },
      {
        path: 'tickets',
        name: 'tickets',
        component: () => import('../client/tickets/support_report'),
      },
      {
        path: 'createtickets',
        name: 'createtickets',
        component: () => import('../client/tickets/createTicket'),
      },
      ,
      {
        path: 'order/confirm',
        name: 'hireconfirm',
        component: () => import('../templates/confirmorder'),
        props: true,
      },
      {
        name: 'client.accountdisable',
        path: 'account',
        component: () => import('../freelancer/account/account'),
      },
      {
        name: 'client.account',
        path: 'account/report',
        component: () => import('../client/accountReport/report.vue'),
      },
    ],
  },
  // {
  // path: '/testclient/abc',
  // name: 'clientDashbord',
  // component: () => import('../../Seller/Dashboard/userdashboard'),
  // }
];
export default routes;
